import React from 'react';
import { SecuritySettings } from 'components/Settings/Sections/SecuritySettings/SecuritySettings';
import { SupportAndFeedback } from 'components/Settings/Sections/SupportAndFeedback/SupportAndFeedback';
import {
  isAccountSettings,
  isNotificationSettings,
  isSecuritySettings,
  isStepCountSettings,
  isSupportSettings,
  isTermsAndAgreements,
} from 'features/settings/types/typeGuards';
import { SettingsSectionId } from 'features/settings/types/types';
import { useNotificationSettings } from 'features/settings/hooks/useNotificationSettings';
import { AccountSettings } from '../Sections/AccountSettings/AccountSettings';
import { NotificationSettings } from '../Sections/NotificationSettings/NotificationSettings';
import { TermsAndAgreements } from '../Sections/TermsAndAgreements';
import { StepCountSettings } from '../Sections/StepCountSettings/StepCountSettings';

interface DesktopSettingsContentProps {
  sectionId: SettingsSectionId;
}

export const DrawerContentSections = ({ sectionId }: DesktopSettingsContentProps) => {
  const { isNotificationFlagEnabled, memberSmsEnabled } = useNotificationSettings();

  return (
    <>
      {isAccountSettings(sectionId) && <AccountSettings />}
      {isNotificationSettings(sectionId) && (isNotificationFlagEnabled || memberSmsEnabled) && (
        <NotificationSettings />
      )}
      {isStepCountSettings(sectionId) && <StepCountSettings stepCountTaskEnabled />}
      {isSecuritySettings(sectionId) && <SecuritySettings />}
      {isSupportSettings(sectionId) && <SupportAndFeedback />}
      {isTermsAndAgreements(sectionId) && <TermsAndAgreements />}
    </>
  );
};
